import { selectorFamily } from 'recoil'
import { buildFrontendLogger, FrontendLogger } from '@/logging/FrontendLogger'

export const LoggerSelectorFamily = selectorFamily<FrontendLogger, string>({
    key: 'LoggerSelectorFamily',
    get: (componentName: string) => () => buildFrontendLogger(componentName),
})
